import {useAuth} from '@apps-common/auth-react';
import {Checkbox, FormControlLabel, FormGroup, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {PERMISSIONS_FILTERS} from '@app/constants/filters';
import useOrgParams from '@app/hooks/useOrgParams';

const PermissionsFilter = ({checkedFilters, onChange}) => {
  const {user} = useAuth();
  const {orgId} = useOrgParams();

  return (
    <>
      <Typography variant="overline">Permissions</Typography>
      <FormGroup sx={{marginInlineStart: 2}}>
        <FormControlLabel
          disabled={orgId && user?.claims.organization_id !== Number(orgId)}
          control={
            <Checkbox color="primary" name={PERMISSIONS_FILTERS.OWNED} />
          }
          checked={!!checkedFilters[PERMISSIONS_FILTERS.OWNED]}
          label="Created by me"
          onChange={e => onChange(e)}
        />
        <FormControlLabel
          disabled={orgId && user?.claims.organization_id !== Number(orgId)}
          control={
            <Checkbox color="primary" name={PERMISSIONS_FILTERS.SHARED} />
          }
          checked={!!checkedFilters[PERMISSIONS_FILTERS.SHARED]}
          label="Shared with organization"
          onChange={e => onChange(e)}
        />
      </FormGroup>
    </>
  );
};

PermissionsFilter.propTypes = {
  checkedFilters: PropTypes.object,
  onChange: PropTypes.func,
};

export default PermissionsFilter;
